import { useQuery } from "@tanstack/react-query";
import type { VehicleMake } from "@spare-cart/contracts/vehicles";
import { apiClient, toQueryRecord } from "@core/api";

export const useVehicleMakesByType = (vehicleTypeSlug: string | undefined) =>
  useQuery({
    queryKey: ["shared", "vehicle-makes", vehicleTypeSlug],
    queryFn: () =>
      apiClient.list<VehicleMake>("/vehicle-makes", {
        query: toQueryRecord({ page: 1, limit: 100, vehicleTypeSlug, isActive: "true" }),
      }),
    enabled: vehicleTypeSlug !== undefined,
  });
